import { useDispatch } from 'react-redux';
import { EAssistantPhase } from '../../../../store/reducers/admin/assistant';
import { updatePhase } from '../../../../store/actions/admin/assistant';
import './menu.scss';

const MenuAssistant: React.FC = () => {

	const dispatch = useDispatch();
	
	return (
		<div className="menu-assistant-container">
			<div className="menu-header">

			</div>
			<div className="menu-body">
				<button className="no-style menu-option" onClick={() => dispatch(updatePhase(EAssistantPhase.PROGRESS))}>
					Progress checklist
				</button>
				<button className="no-style menu-option" onClick={() => dispatch(updatePhase(EAssistantPhase.HELP_CENTER))}>
					Help center
				</button>
				<button className="no-style menu-option" onClick={() => dispatch(updatePhase(EAssistantPhase.WELCOME))}>
					Repeat onboarding tour
				</button>
				<button className="no-style menu-option">
					<a href="https://help.brand.live/hc/en-us/articles/1500000236021-FAQs" target="__blank" rel="noopener">FAQs</a>
				</button>
			</div>
			<div className="menu-footer">

			</div>

		</div>
	);
};

export default MenuAssistant;